import { render } from "./TratamientoDatos.vue?vue&type=template&id=0fdcad3a&scoped=true&ts=true"
import script from "./TratamientoDatos.vue?vue&type=script&lang=ts"
export * from "./TratamientoDatos.vue?vue&type=script&lang=ts"

import "./TratamientoDatos.vue?vue&type=style&index=0&id=0fdcad3a&lang=css&scoped=true"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fdcad3a"]])

export default __exports__